
import { Link } from "react-router-dom"
import Menu from "../Menu"

export default function Header1({ scroll, handleMobileMenu }) {
	return (
		<>
			{/* Top Bar */}
			<div className="proplay-topbar">
				<div className="proplay-container">
					<div className="proplay-topbar-inner">
						{/* Left: Contact Info */}
						<div className="proplay-topbar-left">
							<a href="mailto:info@proplay.in" className="proplay-topbar-contact">
								<svg className="topbar-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
									<rect width="20" height="16" x="2" y="4" rx="2"></rect>
									<path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
								</svg>
								<span>info@proplay.in</span>
							</a>
							<span className="topbar-separator"></span>
							<div className="proplay-topbar-contact">
								<svg className="topbar-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
									<path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
									<circle cx="12" cy="10" r="3"></circle>
								</svg>
								<span>373, GARUDADRI ARCADE, West of Chord Road, Bengaluru-560086</span>
							</div>
						</div>

						{/* Right: Portal Logins */}
						<div className="proplay-topbar-right">
							<a href="https://book.proplay.zone/" target="_blank" rel="noreferrer" className="proplay-portal-btn">
								<svg className="portal-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
									<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
									<circle cx="12" cy="7" r="4"></circle>
								</svg>
								<div className="portal-meta">
									<span className="portal-meta-title">PLAYER LOGIN</span>
									<span className="portal-meta-sub">Book &amp; Play</span>
								</div>
							</a>

							<a href="https://book.proplay.zone/" target="_blank" rel="noreferrer" className="proplay-portal-btn">
								<svg className="portal-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
									<path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
									<path d="M6 12v5c3 3 9 3 12 0v-5"></path>
								</svg>
								<div className="portal-meta">
									<span className="portal-meta-title">STUDENT LOGIN</span>
									<span className="portal-meta-sub">My Academy</span>
								</div>
							</a>

							<a href="https://book.proplay.zone/" target="_blank" rel="noreferrer" className="proplay-portal-btn">
								<svg className="portal-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
									<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
									<circle cx="9" cy="7" r="4"></circle>
									<path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
									<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
								</svg>
								<div className="portal-meta">
									<span className="portal-meta-title">COACH LOGIN</span>
									<span className="portal-meta-sub">Coach Portal</span>
								</div>
							</a>

							<a href="https://book.proplay.zone/" target="_blank" rel="noreferrer" className="proplay-portal-btn">
								<svg className="portal-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
									<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
									<circle cx="9" cy="7" r="4"></circle>
									<path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
									<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
								</svg>
								<div className="portal-meta">
									<span className="portal-meta-title">PARTNER LOGIN</span>
									<span className="portal-meta-sub">Partner Dashboard</span>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>

			{/* Main Navbar */}
			<header id="header" className={`proplay-navbar ${scroll ? 'header-scrolled' : ''}`}>
				<div className="proplay-container">
					<div className="proplay-navbar-inner">
						{/* Logo */}
						<div className="proplay-brand">
							<Link to="/" className="brand-link">
								<img src="images/ProPlayLogo.png" alt="PROPLAY" className="brand-logo-img" />
							</Link>
						</div>

						{/* Navigation Links */}
						<nav id="mainnav" className="proplay-nav">
							<Menu />
						</nav>

						{/* Right CTA */}
						<div className="proplay-nav-action">
							<a href="https://book.proplay.zone/" target="_blank" rel="noreferrer" className="proplay-btn-primary">
								BOOK &amp; PLAY
							</a>
							<button className="mobile-toggle-btn" onClick={handleMobileMenu} aria-label="Toggle navigation">
								<span></span>
								<span></span>
								<span></span>
							</button>
						</div>
					</div>
				</div>
			</header>
		</>
	)
}
